import IndividualCompDetailsContainer from '../common/individual-comp-details-container';
import TeamCompetitionOverviewContainer from './team-competition-overview-container';
import type { GolfEventSummary } from '../types/api.types';

interface TourEventOverviewProps {
  event: GolfEventSummary | undefined | null;
}

export default function TourEventOverview({ event }: TourEventOverviewProps) {
  if (event === undefined || event === null) {
    return null;
  }
  return (
    <div>
      {event.indCompID != null && <IndividualCompDetailsContainer compID={event.indCompID} />}
      {event.teamCompID != null && <TeamCompetitionOverviewContainer compID={event.teamCompID} />}
    </div>
  );
}
